// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_jk-6";
export var emphasizeQuantity = "_jk-3";
export var flatBottomCorners = "_jk-5";
export var productImage = "_jk-0";
export var quantityContainer = "_jk-2";
export var tooltip = "_jk-1";
export var wrapAndEllipsesOverflow = "_jk-4";